import React from "react";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesWrapper1,
  ServicesCard,
  // ServicesIcon,
  ServicesIcon1,
  ServicesIcon2,
  ServicesIcon3,
  ServicesIconc,
  ServicesH2,
  ServicesP,
} from "./ServicesElements";
import Icon1 from "../../images/b11.png";
import Icon2 from "../../images/b2.png";
import Icon3 from "../../images/b3 old.png";
import Icon4 from "../../images/b4.png";
import Icon5 from "../../images/b5.png";
// import Icon6 from "../../images/dslt.png";
// import Icon7 from "../../images/ceo new pic.png";
// import { ButtonR } from "../ButtonElements";
const Services1 = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Members of the Board</ServicesH1>
     
       <ServicesWrapper1>
          <ServicesCard>
          <ServicesIconc src={Icon1} />
          <ServicesH2>Dr. Abdul Mohsen Saad Abdul Rahman Al-Dawoud</ServicesH2>
          <ServicesP>
            Chairman of the Board
          </ServicesP>

          {/* <ButtonR to="/ManagedServices" primary="true" dark="true">
            Read More
          </ButtonR> */}
        </ServicesCard>

        
        <ServicesCard>
          <ServicesIcon3 src={Icon2} />
          <ServicesH2>Vice Chairman of the Board</ServicesH2>
          <ServicesP>
            Ibrahim Abdul Aziz Ibrahim Al-Mahna
          </ServicesP>

          {/* <ButtonR to="/InfrastructureIntegration" primary="true" dark="true">
            Read More
          </ButtonR> */}
        </ServicesCard>

        </ServicesWrapper1>
      <ServicesWrapper>
      
        

        
        <ServicesCard>
          <ServicesIcon1 src={Icon3} />
          <ServicesH2>Board Member - Chief Executive Officer</ServicesH2>
          <ServicesP>
            Abdullah Saeed Abdullah Al-Saber
          </ServicesP>

          {/* <ButtonR to="/FTTx" primary="true" dark="true">
            Read More
          </ButtonR> */}
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon2 src={Icon4} />
          <ServicesH2>Board Member</ServicesH2>
          <ServicesP>
            Ahmed Mohammed Ali Al-Jarallah
          </ServicesP>

          {/* <ButtonR to="/SupportServices" primary="true" dark="true">
            Read More
          </ButtonR> */}
        </ServicesCard>

        <ServicesCard>
          <ServicesIcon2 src={Icon5} />
          <ServicesH2>Board Member</ServicesH2>
          <ServicesP>
          Abdulaziz Hamad Abdulaziz Al-Wanis
          </ServicesP>

          {/* <ButtonR to="/SystemIntegration" primary="true" dark="true">
            Read More
          </ButtonR> */}
        </ServicesCard>

        
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services1;
